import { render, staticRenderFns } from "./RequestViewAssignRequestForm.vue?vue&type=template&id=59168282"
import script from "./RequestViewAssignRequestForm.vue?vue&type=script&lang=js"
export * from "./RequestViewAssignRequestForm.vue?vue&type=script&lang=js"
import style0 from "./RequestViewAssignRequestForm.vue?vue&type=style&index=0&id=59168282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports